// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zone_timeline[data-v-bddf3720]{max-height:calc(100vh - 230px);min-height:calc(100vh - 230px);overflow-y:auto}.zone_timeline_desktop[data-v-bddf3720]{max-height:calc(100vh - 200px);min-height:calc(100vh - 200px);overflow-y:auto}.v-card__text[data-v-bddf3720],.v-card__title[data-v-bddf3720]{word-break:normal}", ""]);
// Exports
module.exports = exports;
